import React from 'react';
import { getYouTubeId } from '../venue-story/utils';

const OVERLAYS = {
  none: 'bg-gradient-to-t from-[#0A1710]/50 via-transparent to-transparent',
  light: 'bg-gradient-to-t from-[#0A1710]/60 via-[#0A1710]/10 to-[#0A1710]/20',
  medium: 'bg-gradient-to-t from-[#0A1710]/85 via-[#0A1710]/20 to-[#0A1710]/40',
  dark: 'bg-gradient-to-t from-[#0A1710]/95 via-[#0A1710]/50 to-[#0A1710]/60'
};

export const HeroBanner = ({ page }) => {
  const hero = page.hero || {};
  const videoId = hero.media_type === 'video' ? getYouTubeId(hero.video_url) : '';
  const image = hero.image_url;
  const mobileImage = hero.mobile_image_url;
  return (
    <section className="relative h-[78vh] md:h-[86vh] flex items-end overflow-hidden bg-[#0A1710]" data-testid="story-hero">
      {videoId ? (
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&rel=0&playsinline=1&modestbranding=1&iv_load_policy=3&disablekb=1&cc_load_policy=0&cc_lang_pref=en`}
            title={page.name}
            className="absolute top-1/2 left-1/2 border-0"
            style={{
              width: 'max(100%, 177.78vh)',
              height: 'max(100%, 56.25vw)',
              transform: 'translate(-50%, -50%) scale(1.35)'
            }}
            allow="autoplay; encrypted-media"
            tabIndex={-1}
            aria-hidden="true"
          />
        </div>
      ) : image ? (
        <div className="absolute inset-0">
          {mobileImage && <img src={mobileImage} alt={page.name} className="md:hidden w-full h-full object-cover" />}
          <img src={image} alt={page.name} className={`${mobileImage ? 'max-md:hidden' : ''} w-full h-full object-cover`} />
        </div>
      ) : null}
      <div className={`absolute inset-0 ${OVERLAYS[hero.overlay] || OVERLAYS.medium}`} />
      <div className="relative w-full font-wvc-body">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-10 pb-12 md:pb-16">
          <div className="wvc-fade-up flex items-center gap-4">
            <span className="h-px w-10 bg-[#C6A87C]" />
            <p className="text-[#C6A87C] uppercase tracking-[0.35em] text-[10px] md:text-xs font-bold" data-testid="story-hero-name">{hero.overline || page.name}</p>
          </div>
          <h1 className="wvc-fade-up-delay-1 font-wvc-display text-5xl sm:text-6xl lg:text-7xl text-[#FDFCF8] font-light leading-[0.95] tracking-tighter mt-5 max-w-4xl" data-testid="story-hero-headline">
            {hero.headline || page.name}
          </h1>
          {hero.subheadline && <p className="wvc-fade-up-delay-2 text-[#FDFCF8]/70 mt-5 max-w-lg text-sm md:text-base font-light">{hero.subheadline}</p>}
        </div>
      </div>
    </section>
  );
};
